import CellHOC from '@platform/react/hoc/list/cell'
import ApplicationContext from 'platform/react/context/application'
import { useContext } from 'react'
import Text from 'ui/Element/Text'

/**
 * Displays information about the submit date of a measurement.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
const ListItemCellXEcoApmSubmit = (classes, props = {}) => {
  const { intl } = useContext(ApplicationContext)
  const { submit: { timestamp = null } } = props

  const date = timestamp
    ? intl.getLocaleDate(timestamp, { dateStyle: 'short', timeStyle: 'short' })
    : null

  return (
    <Text
      color={'black'}
      variant={'14/medium'}
      className={classes.row}
    >
      {date}
    </Text>
  )
}

export default CellHOC(ListItemCellXEcoApmSubmit)
